import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import router from "@/router";
import getUserInfoByUserId from "../data/getUserInfoByUserId";

Vue.use(Vuex);
export const store = new Vuex.Store({
  state: {
    appTitle: "Thaisook Web Admin",
    user: null,
    error: null,
    loading: false,
    isAuthenticated: false,
    isSuperAdmin: false,
    isChallengeAdmin: false,
    isAccessQuiz: false,
    isAccessOnlineSurvey: false,
    isAccessCoachAdmin: false,
    isAccessOrgAdmin: false,
    isAccessPILMAdmin: false,
    loggedInUsername: null,
    loggedInUserId: null,
    loggedInPhoneNumber: null,
    isAccessRewardProduct: false,
    isAccessDownloadThaisookWatch: false,
  },
  mutations: {
    setUser(state, payload) {
      if (payload != null) {
        (async () => {
          const userInfo = await getUserInfoByUserId(payload.uid);
          state.user = userInfo;
          state.loggedInUserId = userInfo.uid;
          state.loggedInUsername = userInfo.name;
          state.loggedInPhoneNumber = userInfo.phoneNumber;
          state.isAuthenticated = true;

          if (userInfo.role == "superAdmin") {
            state.isSuperAdmin = true;
          } else if (userInfo.role == "challengeAdmin") {
            state.isChallengeAdmin = true;
          }
          let permissionList = [];
          if( userInfo.permissions != undefined && userInfo.permissions.length ){
            permissionList = userInfo.permissions;
          }
          if( permissionList.includes('accessQuiz') || userInfo.role == "superAdmin" ){
            state.isAccessQuiz = true;
          }
          if( permissionList.includes('accessOnlineSurvey') || userInfo.role == "superAdmin" ){
            state.isAccessOnlineSurvey = true;
          }
          if( permissionList.includes('accessCoachAdmin') || userInfo.role == "superAdmin" ){
            state.isAccessCoachAdmin = true;
          }
          if( permissionList.includes('accessOrgAdmin') || userInfo.role == "superAdmin" ){
            state.isAccessOrgAdmin = true;
          }
          if( permissionList.includes('accessPILMAdmin') || userInfo.role == "superAdmin" ){
            state.isAccessCoachAdmin = true;
            state.isAccessOrgAdmin = true;
            state.isAccessPILMAdmin = true;
          }
          if( permissionList.includes('accessRewardProduct') || userInfo.role == "superAdmin" ){
            state.isAccessRewardProduct = true;
          }
          if( permissionList.includes('downloadThaisookWatch') || userInfo.role == "superAdmin" ){
            state.isAccessDownloadThaisookWatch = true;
          }
        })();
      }
      else{
        state.appTitle =  "Thaisook Web Admin",
        state.user = null,
        state.error = null;
        state.loading = false;
        state.isAuthenticated = false;
        state.isSuperAdmin = false;
        state.isAccessQuiz = false;
        state.isAccessOnlineSurvey = false;
        state.isChallengeAdmin = false;
        state.isAccessOrgAdmin = false;
        state.isAccessCoachAdmin = false;
        state.isAccessPILMAdmin = false;
        state.isAccessRewardProduct = false;
        state.isAccessDownloadThaisookWatch = false;
        state.loggedInUsername = null;
        state.loggedInUserId = null;
        state.loggedInPhoneNumber = null;
      }
    },
    setError(state, payload) {
      state.error = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
  },
  actions: {
    autoSignIn({ commit }, payload) {
      commit("setUser", payload);
    },
    userSignOut({ commit }) {
      firebase.auth().signOut();
      commit("setUser", null);
      router.push("/");
    },
  },
  getters: {
    appTitle(state) {
      return state.appTitle;
    },
    isAuthenticated(state) {
      return state.isAuthenticated;
    },
    isSuperAdmin(state) {
      return state.isSuperAdmin;
    },
    isChallengeAdmin(state) {
      return state.isChallengeAdmin;
    },
    loggedInUserId(state) {
      return state.loggedInUserId;
    },
    loggedInUsername(state) {
      return state.loggedInUsername;
    },
    loggedInPhoneNumber(state) {
      return state.loggedInPhoneNumber;
    },
    isAccessQuiz(state){
      return state.isAccessQuiz;
    },
    isAccessOnlineSurvey(state){
      return state.isAccessOnlineSurvey;
    },
    isAccessCoachAdmin(state){
      return state.isAccessCoachAdmin;
    },
    isAccessOrgAdmin(state){
      return state.isAccessOrgAdmin;
    },
    isAccessPILMAdmin(state){
      return state.isAccessPILMAdmin;
    },
    isAccessRewardProduct(state){
      return state.isAccessRewardProduct;
    },
    isAccessDownloadThaisookWatch(state){
      return state.isAccessDownloadThaisookWatch;
    }
  },
});
